import { RolI } from "interfaces/Rol";

export interface infoFetchGetRolesI {
  id: number | string;
  nombre: string;
}

class Rol implements RolI {
  id: number | string;
  nombre: string;

  constructor(infoFetch: infoFetchGetRolesI) {
    this.id = infoFetch.id;
    this.nombre = infoFetch.nombre;
  }
}

export const makeRol = (infoFetch: infoFetchGetRolesI) => {
  return new Rol(infoFetch);
};
